//import React, { useState, useEffect } from "react";
//import { useSelector } from "react-redux";
//import OverView from "./OverView/OverView";
//import ServiceRequestChart from "./ServiceRequestChart/ServiceRequestChart";
//import CountryPieChart from "./CountryPieChart/CountryPieChart";
//import ServiceRequestRange from "./ServiceRequestRange/ServiceRequestRange";
//import ViolationRange from "./ViolationRange/ViolationRange";
//import DashboardServiceRequest from "./DashboardServiceRequest/DashboardServiceRequest";
//import DashboardPayment from "./DashboardPayment/DashboardPayment";
//import DashboardViolation from "./DashboardViolation/DashboardViolation";
//import DashboardMetrics from "./DashboardMetrics/DashboardMetrics";
//import TodoList from "./TodoList/TodoList";
//import DashboardChart from "./DashboardChart/DashboardChart";
//import useAxiosInstance from "../../services/useAxiosInstance";
//import { Calendar, BarChart2, Clock, ChevronDown } from "lucide-react";

//const Dashboard = () => {
//  const axiosInstance = useAxiosInstance();
//  const roleId = useSelector((state) => state.auth.roleId);
//  const [selectedOption, setSelectedOption] = useState("Last Year");
//  const [startDate, setStartDate] = useState("");
//  const [endDate, setEndDate] = useState("");
//  const [dropdownOpen, setDropdownOpen] = useState(false);

//  const handleDateRangeChange = (option) => {
//    setSelectedOption(option);
//    const currentDate = new Date();
//    let newStartDate = "";
//    let newEndDate = currentDate.toISOString().split("T")[0];

//    switch (option) {
//      case "Today":
//        newStartDate = newEndDate;
//        break;
//      case "Last Week":
//        const startOfWeek = new Date(currentDate);
//        startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
//        newStartDate = startOfWeek.toISOString().split("T")[0];
//        break;
//      case "Last Month":
//        const startOfMonth = new Date(
//          currentDate.getFullYear(),
//          currentDate.getMonth(),
//          1
//        );
//        newStartDate = startOfMonth.toISOString().split("T")[0];
//        break;
//      case "Last Year":
//        const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
//        newStartDate = startOfYear.toISOString().split("T")[0];
//        break;
//      case "All Dates":
//        newStartDate = "";
//        newEndDate = "";
//        break;
//      default:
//        break;
//    }

//    setStartDate(newStartDate);
//    setEndDate(newEndDate);
//    setDropdownOpen(false);
//  };

//  useEffect(() => {
//    handleDateRangeChange("Last Year");
//  }, []);

//  const getDateRangeIcon = () => {
//    switch (selectedOption) {
//      case "Today":
//        return <Clock size={18} />;
//      default:
//        return <Calendar size={18} />;
//    }
//  };

//  return (
//    <div className="bg-gray-50 min-h-screen">
//      <div className="max-w-7xl mx-auto px-4 py-6">
//        {(roleId === 1000 || roleId === 1001 || roleId === 1002 || roleId === 1003) && (
//          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
//            <div>
//              <h1 className="text-2xl font-bold text-gray-800 mb-1">Dashboard</h1>
//              <p className="text-sm text-gray-500">Overview of your community activity</p>
//            </div>

//            <div className="mt-4 sm:mt-0 relative">
//              <button
//                className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
//                onClick={() => setDropdownOpen(!dropdownOpen)}
//              >
//                {getDateRangeIcon()}
//                <span>{selectedOption}</span>
//                <ChevronDown size={16} className={`transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
//              </button>

//              {dropdownOpen && (
//                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
//                  <ul className="py-1">
//                    <li>
//                      <button
//                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
//                        onClick={() => handleDateRangeChange("Today")}
//                      >
//                        Today
//                      </button>
//                    </li>
//                    <li>
//                      <button
//                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
//                        onClick={() => handleDateRangeChange("Last Week")}
//                      >
//                        Last Week
//                      </button>
//                    </li>
//                    <li>
//                      <button
//                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
//                        onClick={() => handleDateRangeChange("Last Month")}
//                      >
//                        Last Month
//                      </button>
//                    </li>
//                    <li>
//                      <button
//                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
//                        onClick={() => handleDateRangeChange("Last Year")}
//                      >
//                        Last Year
//                      </button>
//                    </li>
//                    <li>
//                      <button
//                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
//                        onClick={() => handleDateRangeChange("All Dates")}
//                      >
//                        All Dates
//                      </button>
//                    </li>
//                  </ul>
//                </div>
//              )}
//            </div>
//          </div>
//        )}

//        <div className="mb-6">
//          <OverView startDate={startDate} endDate={endDate} />
//        </div>

//        {roleId === 1000 && (
//          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
//            <div className="lg:col-span-3 bg-white rounded-lg shadow-sm overflow-hidden">
//              <ServiceRequestChart
//                startDate={startDate}
//                endDate={endDate}
//              />
//            </div>
//            <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden">
//              <CountryPieChart startDate={startDate} endDate={endDate} />
//            </div>
//          </div>
//              )}
//        {/* Replace the separate TodoList and DashboardChart sections with this grid layout */}
//        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
//          {/* Financial Summary (DashboardChart) - Left side */}
//          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//            <div className="flex items-center p-4 border-b ">
//              <BarChart2 size={20} className="text-blue-500 mr-2" />
//              <h2 className="text-xl font-bold text-gray-800">Financial Summary</h2>
//            </div>
//              <DashboardChart />
//          </div>

//          {/* Event Calendar (TodoList) - Right side */}
//          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//            <div className="flex items-center p-4 border-b">
//              <BarChart2 size={20} className="text-blue-500 mr-2" />
//              <h2 className="text-xl font-bold text-gray-800">Event Calendar</h2>
//            </div>
//            <TodoList />
//          </div>
//        </div>
//        <div className="mb-6">
//          <DashboardViolation />
//        </div>

//        {(roleId === 1003) && (
//          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
//            <div className="lg:col-span-3 bg-white rounded-lg shadow-sm overflow-hidden">
//              <DashboardServiceRequest
//                startDate={startDate}
//                endDate={endDate}
//              />
//            </div>
//            <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden">
//              <DashboardPayment startDate={startDate} endDate={endDate} />
//            </div>
//          </div>
//        )}

//        {(roleId === 1002 || roleId === 1001) && (
//          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
//            <div className="lg:col-span-3 bg-white rounded-lg shadow-sm overflow-hidden">
//              <ServiceRequestRange
//                startDate={startDate}
//                endDate={endDate}
//              />
//            </div>
//            <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden">
//              <ViolationRange startDate={startDate} endDate={endDate} />
//            </div>
//          </div>
//        )}
//      </div>
//    </div>
//  );
//};

//export default Dashboard;

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import OverView from "./OverView/OverView";
import ServiceRequestChart from "./ServiceRequestChart/ServiceRequestChart";
import CountryPieChart from "./CountryPieChart/CountryPieChart";
import ServiceRequestRange from "./ServiceRequestRange/ServiceRequestRange";
import ViolationRange from "./ViolationRange/ViolationRange";
import DashboardServiceRequest from "./DashboardServiceRequest/DashboardServiceRequest";
import DashboardPayment from "./DashboardPayment/DashboardPayment";
import DashboardViolation from "./DashboardViolation/DashboardViolation";
import TodoList from "./TodoList/TodoList";
import DashboardChart from "./DashboardChart/DashboardChart";
import useAxiosInstance from "../../services/useAxiosInstance";
import { Calendar, BarChart2, Clock, ChevronDown } from "lucide-react";
import ChatWidget from "../../chatbot-component/ChatWidget";
import BotpressChatWidget from "../../chatbot-component/BotpressChatWidget";


const Dashboard = () => {
    const axiosInstance = useAxiosInstance();
    const roleId = useSelector((state) => state.auth.roleId);
    const [selectedOption, setSelectedOption] = useState("Last Year");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDateRangeChange = (option) => {
        setSelectedOption(option);
        const currentDate = new Date();
        let newStartDate = "";
        let newEndDate = currentDate.toISOString().split("T")[0];

        switch (option) {
            case "Today":
                newStartDate = newEndDate;
                break;
            case "Last Week":
                const startOfWeek = new Date(currentDate);
                startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
                newStartDate = startOfWeek.toISOString().split("T")[0];
                break;
            case "Last Month":
                const startOfMonth = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    1
                );
                newStartDate = startOfMonth.toISOString().split("T")[0];
                break;
            case "Last Year":
                const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
                newStartDate = startOfYear.toISOString().split("T")[0];
                break;
            case "All Dates":
                newStartDate = "";
                newEndDate = "";
                break;
            default:
                break;
        }

        setStartDate(newStartDate);
        setEndDate(newEndDate);
        setDropdownOpen(false);
    };

    useEffect(() => {
        handleDateRangeChange("Last Year");
    }, []);

    const getDateRangeIcon = () => {
        switch (selectedOption) {
            case "Today":
                return <Clock size={18} />;
            default:
                return <Calendar size={18} />;
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto px-4 py-6">
                {/* Date Range Selector - Show for all roles except pure sales roles in some contexts */}
                {(roleId === 1000 || roleId === 1001 || roleId === 1002 || roleId === 1003) && (
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800 mb-1">Dashboard</h1>
                            <p className="text-sm text-gray-500">
                                {roleId === 1000 ? "System-wide overview" :
                                    roleId === 1001 || roleId === 1002 ? "Community overview" :
                                        roleId === 1003 ? "Your personal overview" : "Overview"}
                            </p>
                        </div>

                        <div className="mt-4 sm:mt-0 relative">
                            <button
                                className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                            >
                                {getDateRangeIcon()}
                                <span>{selectedOption}</span>
                                <ChevronDown size={16} className={`transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                            </button>

                            {dropdownOpen && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
                                    <ul className="py-1">
                                        <li>
                                            <button
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                                                onClick={() => handleDateRangeChange("Today")}
                                            >
                                                Today
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                                                onClick={() => handleDateRangeChange("Last Week")}
                                            >
                                                Last Week
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                                                onClick={() => handleDateRangeChange("Last Month")}
                                            >
                                                Last Month
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                                                onClick={() => handleDateRangeChange("Last Year")}
                                            >
                                                Last Year
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                                                onClick={() => handleDateRangeChange("All Dates")}
                                            >
                                                All Dates
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Sales Dashboard Header */}
                {(roleId === 1004 || roleId === 1005) && (
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800 mb-1">Sales Dashboard</h1>
                            <p className="text-sm text-gray-500">
                                {roleId === 1004 ? "Sales management overview" : "Your sales performance"}
                            </p>
                        </div>
                    </div>
                )}

                {/* Overview Section - Universal */}
                <div className="mb-6">
                    <OverView startDate={startDate} endDate={endDate} />
                </div>

                {/* Superadmin Layout - Everything */}
                {roleId === 1000 && (
                    <>
                        {/* Charts Row */}
                        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
                            <div className="lg:col-span-3 bg-white rounded-lg shadow-sm overflow-hidden">
                                <ServiceRequestChart startDate={startDate} endDate={endDate} />
                            </div>
                            <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden">
                                <CountryPieChart startDate={startDate} endDate={endDate} />
                            </div>
                        </div>

                        {/* Financial Summary & Event Calendar */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <BarChart2 size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Financial Summary</h2>
                                </div>
                                <DashboardChart roleId={roleId} />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <Calendar size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Event Calendar</h2>
                                </div>
                                <TodoList />
                            </div>
                        </div>

                        {/* Management Components - 50/50 Split */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <ServiceRequestRange startDate={startDate} endDate={endDate} />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <ViolationRange startDate={startDate} endDate={endDate} />
                            </div>
                        </div>

                        {/* Violations */}
                        <div className="mb-6">
                            <DashboardViolation />
                        </div>

                        {/* User Components - Full Width One After Other */}
                        <div className="mb-6">
                            <DashboardServiceRequest startDate={startDate} endDate={endDate} />
                        </div>

                        <div className="mb-6">
                            <DashboardPayment startDate={startDate} endDate={endDate} />
                        </div>
                    </>
                )}

                {/* HOA Admin & Board Member Layout */}
                {(roleId === 1001 || roleId === 1002) && (
                    <>
                        {/* Charts Row */}
                        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6">
                            <div className="lg:col-span-3 bg-white rounded-lg shadow-sm overflow-hidden">
                                <ServiceRequestChart startDate={startDate} endDate={endDate} />
                            </div>
                            <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden">
                                <CountryPieChart startDate={startDate} endDate={endDate} />
                            </div>
                        </div>

                        {/* Financial Summary & Event Calendar */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <BarChart2 size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Community Financials</h2>
                                </div>
                                <DashboardChart roleId={roleId} />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <Calendar size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Event Calendar</h2>
                                </div>
                                <TodoList />
                            </div>
                        </div>

                        {/* Management Components - 50/50 Split */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <ServiceRequestRange startDate={startDate} endDate={endDate} />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <ViolationRange startDate={startDate} endDate={endDate} />
                            </div>
                        </div>

                        {/* Violations */}
                        <div className="mb-6">
                            <DashboardViolation />
                        </div>
                    </>
                )}

                {/* User Layout */}
                {roleId === 1003 && (
                    <>
                        {/* Financial Summary & Event Calendar */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <BarChart2 size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">My Services</h2>
                                </div>
                                <DashboardServiceRequest />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4 border-b">
                                    <Calendar size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Event Calendar</h2>
                                </div>
                                <TodoList />
                            </div>
                        </div>
                    </>
                )}

                {/* Sales Layout */}
                {(roleId === 1004 || roleId === 1005) && (
                    <>
                        {/* Sales Financial Summary & Event Calendar */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4">
                                    <BarChart2 size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Sales Performance</h2>
                                </div>
                                <DashboardChart roleId={roleId} />
                            </div>
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <div className="flex items-center p-4">
                                    <Calendar size={20} className="text-blue-500 mr-2" />
                                    <h2 className="text-xl font-bold text-gray-800">Event Calendar</h2>
                                </div>
                                <TodoList />
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/*<ChatWidget />*/}
            {/*<BotpressChatWidget />*/}

        </div>
    );
};

export default Dashboard;